(function () {
  // import
  // structv2
  // hexToRGB
  // Customization
  // tv_sel_block
  // tv_cur_elem

  var isPopupOpen = false;

  function toggleLanguagePopup() {
    if (isPopupOpen) {
      hideLanguagePopup();
      isPopupOpen = false;
    } else {
      showLanguagePopup();
      isPopupOpen = true;
    }
  }

  // TODO REMOVE IT AND USE FROM src/app/core/utils/format-language-title.ts
  function formatLanguageTitle(title) {
    return title.replace(/^(.+?)\s*(\(.+\))$/, '<span lang="en">$1</span> $2');
  }

  function showLanguagePopup() {
    // Получение списка языков из structv2
    var languages = structv2.language;

    // Get the language selector element
    var languageSelector = document.querySelector('[data-widget="language-selector"]');
    if (!languageSelector || languages.length < 2) {
      console.error('Language selector element (data-widget="language-selector") not found.');
      return;
    }

    // Remove any existing popup
    var existingPopup = document.querySelector('.language-popup');
    if (existingPopup) {
      existingPopup.remove();
    }

    // Create the popup container
    var popup = document.createElement('div');
    popup.classList.add('language-popup');
    popup.style.backgroundColor = hexToRGB(Customization.get('main_background'), 0.8);

    // Add each language to the popup as a list item
    languages.forEach(function (language) {
      var languageItem = document.createElement('div');
      languageItem.classList.add('language-popup-item');
      languageItem.classList.add('not_tv_cur');

      languageItem.innerHTML = formatLanguageTitle(language.title);
      languageItem.style.color = Customization.get('main_color');

      languageItem.setAttribute('lang', language.code);
      languageItem.setAttribute('onvclick', 'change_language("' + language.code + '")');
      languageItem.setAttribute('onvleave', 'handleLanguageItemOnVLeave()');
      languageItem.setAttribute('selectable', '');
      languageItem.setAttribute('clickable', '');

      popup.appendChild(languageItem);
    });

    // Add the popup to the DOM
    languageSelector.appendChild(popup);

    // Position the popup below the language selector
    var rect = languageSelector.getBoundingClientRect();
    var popupWidth = popup.clientWidth;
    var popupHeight = popup.clientHeight;
    var screenWidth = window.innerWidth;
    var screenHeight = window.innerHeight;

    // Выравниваем правый край попапа с правым краем кнопки
    var left = rect.width - popupWidth;
    var top = rect.height + 5;

    // Не даём попапу выйти за правый край экрана
    if (rect.left + left + popupWidth > screenWidth - 5) {
      left = screenWidth - rect.left - popupWidth - 5;
    }
    // Не даём выйти за левый край
    if (rect.left + left < 5) {
      left = -rect.left + 5;
    }
    // Не даём выйти за нижний край — показываем над селектором
    if (rect.bottom + 5 + popupHeight > screenHeight) {
      top = -popupHeight - 5;
    }

    popup.style.left = left + 'px';
    popup.style.top = top + 'px';

    tv_sel_block();
  }

  function handleLanguageItemOnVLeave() {
    var parent = tv_cur_elem.parent();
    if (!parent.hasClass('language-popup')) {
      toggleLanguagePopup();
    }
  }

  function hideLanguagePopup() {
    document.querySelector('.language-popup').remove();
    tv_sel_block();
  }

  window.toggleLanguagePopup = toggleLanguagePopup;
  window.handleLanguageItemOnVLeave = handleLanguageItemOnVLeave;
})();
